import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React, { useCallback } from 'react';
import useDoubleClick from "../../../hooks/useDoubleClick";
import { CardBody, CardBodyContent, CardBodyActions } from "../../style/card";
import { NoteTemplateCard, _TitleWrapper, _Title, _Description } from "./styles";
import NoteTemplateOptionsMenu from "./NoteTemplateOptionsMenu";
var NoteTemplate = function NoteTemplate(_ref) {
  var clickable = _ref.clickable,
    deletable = _ref.deletable,
    noteTemplate = _ref.noteTemplate,
    onArchiveTemplate = _ref.onArchiveTemplate,
    onClickProp = _ref.onClick,
    onDeleteTemplateProp = _ref.onDeleteTemplate,
    onDoubleClick = _ref.onDoubleClick,
    selected = _ref.selected;
  var id = noteTemplate.id,
    archived = noteTemplate.archived,
    title = noteTemplate.title,
    description = noteTemplate.description;
  var onClick = useDoubleClick(function (event) {
    return onClickProp && onClickProp(event, noteTemplate);
  }, function (event) {
    return onDoubleClick && onDoubleClick(event, noteTemplate);
  }, [onClickProp, onDoubleClick, noteTemplate]);
  var onDeleteTemplate = useCallback(function (event) {
    return onDeleteTemplateProp && onDeleteTemplateProp(event, noteTemplate);
  }, [onDeleteTemplateProp, noteTemplate]);
  var onToggleArchiveTemplate = onArchiveTemplate ? function () {
    return onArchiveTemplate(id, !archived);
  } : null;
  return /*#__PURE__*/React.createElement(NoteTemplateCard, {
    onClick: onClick,
    selected: selected,
    clickable: clickable
  }, /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(CardBodyContent, null, /*#__PURE__*/React.createElement(_TitleWrapper, null, /*#__PURE__*/React.createElement(_Title, null, "[", id, "] ", title), /*#__PURE__*/React.createElement(_Description, null, description))), /*#__PURE__*/React.createElement(CardBodyActions, null, /*#__PURE__*/React.createElement(NoteTemplateOptionsMenu, {
    archiveLabel: archived ? 'Activate' : 'Archive',
    onArchive: onToggleArchiveTemplate,
    onDelete: deletable && onDeleteTemplate
  }))));
};
export default NoteTemplate;